import { useLocation, useNavigate } from 'react-router-dom';
import { BrandLogo } from '../layout/components/brand-logo/brand-logo';
import { OnboardingModal, type Feature } from './onboarding-modal';

export const features: Feature[] = [
  {
    title: 'Introduction & Use Case',
    description:
      'The driving use case of the Permissioning UI is to fulfil a newly signed contract for delivering XF files to customers via the SFTP platform. The application is also expected to onboard all of the existing business lines onto its realm.',
  },
  {
    title: 'Authentication & Authorization',
    description: 'The application uses U6 for authentication and N6 Entitle for entitlements.',
  },
  {
    title: 'Types of Users',
    description: (
      <div>
        <p className='mb-3 text-left'>There are 3 primary types of users to the Permissioning UI:</p>
        <ul className='text-left'>
          <li className='mb-3'>
            <strong>Operator</strong> - A super admin role that has a broad range of operations possible. This is currently granted only to Data Delivery Client Services.
          </li>
          <li className='mb-3'>
            <strong>Self-Service</strong> - Limited admin capabilities to fulfil the needs of a particular business line.
          </li>
          <li className='mb-3'>
            <strong>Read-Only</strong> - Read only access for a particular business line.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: 'How to request access for Permissioning UI',
    description: (
      <p>
        Send an email to{' '}
        <a className='text-blue-300' href='mailto:data.delivery@spglobal.com'>
          data.delivery@spglobal.com
        </a>{' '}
        with the subject line <strong>Request for access to PCSFTP Permissioning UI</strong>.
      </p>
    ),
  },
  {
    title: 'Thank you!',
    description: 'You can now login to the application and start using it.',
  },
];

export const onboardingStorageKey = 'hasSeenOnboarding';

export const WebInfoSlides = ({ redirectPath }: { redirectPath: string }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onFinish = () => {
    localStorage.setItem(onboardingStorageKey, 'true');
    navigate(redirectPath, { state: { from: location }, replace: true });
  };

  return (
    <OnboardingModal features={features} hasSeenOnboarding={Boolean(localStorage.getItem(onboardingStorageKey))} onFinish={onFinish} onClose={onFinish} storageKey={onboardingStorageKey}>
      <BrandLogo text='PC SFTP Permissioning UI' logoClassName='text-black w-[130px] dark:text-white' textClassName='text-sm font-medium text-black dark:text-white mr-12' />
    </OnboardingModal>
  );
};
